import { MapOutlined } from "@mui/icons-material";
import isNil from "lodash/isNil";
import { useMemo } from "react";
import AzureMap from "../AzureMap";
import Flx from "../layout/Flx";
import Txt from "../typography/Txt";

const AddressMap = ({ address, height = "200px", sx }) => {
  const latitude = useMemo(() => address?.latitude, [address?.latitude]);
  const longitude = useMemo(() => address?.longitude, [address?.longitude]);

  if (isNil(latitude) || isNil(longitude)) {
    return (
      <Flx
        center
        sx={{
          height,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: "#f5f5f5",
          gap: 1,
          ...sx,
        }}
      >
        <MapOutlined sx={{ color: "#666", fontSize: "2rem" }} />
        <Txt sx={{ color: "#666" }}>No location available</Txt>
      </Flx>
    );
  }
  return <AzureMap height={height} latitude={latitude} longitude={longitude} />;
};
export default AddressMap;
